package com.dotdrives.client
import com.dotdrives.model.*
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.postgrest.postgrest
import kotlinx.serialization.json.*
import kotlin.time.Instant
class DashboardClient(private val client:SupabaseClient=SupabaseProvider.client) {
 suspend fun snapshot(orgId:String,asOf:Instant):DashboardSnapshot=client.postgrest.rpc("dashboard_snapshot",params(orgId,asOf)).decodeAs()
 suspend fun queue(orgId:String,asOf:Instant):List<DashboardQueueItem> = fetchAllPages(100) { offset ->
  client.postgrest.rpc("dashboard_queue",buildJsonObject { put("p_org",orgId);put("p_as_of",asOf.toString());put("p_offset",offset);put("p_limit",100) }).decodeAs<List<DashboardQueueItem>>()
 }
 suspend fun acknowledge(orgId:String,id:String) { client.postgrest.rpc("acknowledge_donation",buildJsonObject { put("p_org",orgId);put("p_donation",id) }) }
 private fun params(orgId:String,asOf:Instant)=buildJsonObject {put("p_org",orgId);put("p_as_of",asOf.toString())}
}
